import { render, staticRenderFns } from "./SsCard.vue?vue&type=template&id=50ac0244&scoped=true"
import script from "./SsCard.vue?vue&type=script&lang=js"
export * from "./SsCard.vue?vue&type=script&lang=js"
import style0 from "./SsCard.vue?vue&type=style&index=0&id=50ac0244&prod&lang=scss&scoped=true"
import style1 from "./SsCard.vue?vue&type=style&index=1&id=50ac0244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ac0244",
  null
  
)

export default component.exports